module.exports = __webpack_public_path__ + "img/slide-8-4.9e8d99ab.jpg";